import Commercial from '../Component/Commercial';
import { connect } from 'react-redux';
import {
  verifyEmail,
  addCommercialProposal,
  addCommercialQuote,
  updateCommercialQuote,
  updateCommercialProposal,
  updateInnerCommercialProposal,
  checkEmail,
  getAccountInfo,
  addInnerCommercialProposal,
  resetProposal,
  getGeocodeAddress,
  resetGeocodeAddress,
  getQuoteById,
  getHistoricalData,
  updateCustomerLastCompletedStep
} from "../../../Actions";

const mapStateToProps = (state) => {
  const {
    AccountInfo,
    GoogleApi,
    ResRegister
  } = state;
  const { 
    quote,
    loading,
    error,
    proposal,
    addInnerProposal,
    quote_info 
  } = state.commercialQuote;
 
  return {
    quote,
    loading,
    error,
    proposal,
    quote_info,
    addInnerProposal,
    AccountInfo,
    GoogleApi,
    email: state.email,
  }
};

const mapDispatchToProps = {
  addCommercialQuote,
  addCommercialProposal,
  updateCommercialQuote,
  updateCommercialProposal,
  updateInnerCommercialProposal,
  addInnerCommercialProposal,
  resetProposal,
  checkEmail,
  verifyEmail,
  getAccountInfo,
  getGeocodeAddress,
  resetGeocodeAddress,
  getQuoteById,
  getHistoricalData,
  updateCustomerLastCompletedStep
};

export default (connect(mapStateToProps, mapDispatchToProps)(Commercial));